/* Remood — Vanilla JS */

document.addEventListener('DOMContentLoaded', () => {

  /* Marquee — duplicate content for seamless loop */
  document.querySelectorAll('.marquee-track').forEach(track => {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });

  /* Navigation (header, mega menus, tiroir, annonces) : voir remood-nav.js */

  /* Back to top — arrow appears after scrolling down */
  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    backToTop.hidden = false;
    const toggleBtt = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      backToTop.classList.toggle('is-visible', y > 600);
    };
    window.addEventListener('scroll', toggleBtt, { passive: true });
    toggleBtt();
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Sticky bottom CTA — appears after scrolling past hero
     (la barre ATC produit .m-pdp-cta est pilotée par sa propre section) */
  const cta = document.querySelector('.m-cta:not(.m-pdp-cta)');
  if (cta) {
    let lastY = 0;
    const threshold = 380;
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y < threshold) {
        cta.classList.remove('visible');
      } else if (y > lastY) {
        cta.classList.add('visible');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Scroll-triggered section reveals (Intersection Observer) */
  const REVEAL_SEL = '.reveal-section, .reveal-item, .reveal-stagger';
  const designMode = window.Shopify && window.Shopify.designMode;

  if (designMode || !('IntersectionObserver' in window)) {
    /* Éditeur de thème : les sections sont re-rendues à chaque réglage et
       perdraient .is-visible pour toujours — on désactive l'animation. */
    const revealAll = (root) => {
      root.querySelectorAll(REVEAL_SEL).forEach(el => el.classList.add('is-visible'));
      if (root !== document && root.matches && root.matches(REVEAL_SEL)) root.classList.add('is-visible');
    };
    revealAll(document);
    document.addEventListener('shopify:section:load', (e) => revealAll(e.target));
    document.addEventListener('shopify:block:select', (e) => revealAll(e.target));
  } else {
    /* threshold: 0 — un seuil en % ne se déclenche jamais sur les sections
       beaucoup plus hautes que le viewport */
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll(REVEAL_SEL).forEach(el => {
      /* Déjà dans le viewport (arrivée par ancre, bfcache, bas de page) :
         visible tout de suite, sans attendre le premier scroll */
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-visible');
      else revealObs.observe(el);
    });
  }

  /* Image fade-in on load — listener capturant au niveau document pour
     couvrir aussi les images injectées en Ajax (tiroir panier, recherche
     prédictive, load-more) : l'événement load ne bulle pas, capture=true */
  document.querySelectorAll('img').forEach(img => {
    if (img.complete) img.classList.add('loaded');
  });
  document.addEventListener('load', (e) => {
    if (e.target.tagName === 'IMG') e.target.classList.add('loaded');
  }, true);

});

/* =========================================================
   PAGE PRODUIT — PDP
   ========================================================= */
(function () {
  if (!document.querySelector('.pdp-wrap')) return;

  const P = window.RemoodProduct || {};
  const variants = P.variants || [];
  const labels = {};
  /* Collect gallery labels from section settings (injected via schema) */
  document.querySelectorAll('[data-thumb]').forEach(btn => {
    labels[parseInt(btn.dataset.thumb)] = btn.dataset.label || '';
  });

  /* ── Galerie ── */
  const mainEl    = document.getElementById('gallery-main');
  const thumbsWrap = document.getElementById('gallery-thumbs');
  const labelEl   = document.getElementById('gallery-label');
  const counterEl = document.getElementById('gallery-current');
  const islandEl  = document.getElementById('gallery-nav-island');

  function goSlide(idx) {
    document.querySelectorAll('.gallery-slide').forEach((s, i) => {
      s.classList.toggle('active', i === idx);
      s.setAttribute('aria-hidden', i !== idx ? 'true' : 'false');
    });
    document.querySelectorAll('.gallery-thumb').forEach((t, i) => {
      t.classList.toggle('active', i === idx);
      t.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
    });
    document.querySelectorAll('.gallery-dot').forEach((d, i) => {
      d.classList.toggle('active', i === idx);
      d.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
    });
    if (labelEl && labels[idx]) labelEl.textContent = labels[idx];
    if (counterEl) counterEl.textContent = String(idx + 1).padStart(2, '0');
    if (islandEl) {
      islandEl.querySelectorAll('.gni-tab').forEach(btn => {
        const match = parseInt(btn.dataset.gniIndex, 10) === idx;
        btn.classList.toggle('active', match);
        btn.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    }
  }

  if (thumbsWrap) {
    thumbsWrap.querySelectorAll('.gallery-thumb').forEach((btn, i) => {
      btn.addEventListener('click', () => goSlide(i));
    });
  }

  document.querySelectorAll('.gallery-dot').forEach((btn, i) => {
    btn.addEventListener('click', () => goSlide(i));
  });

  if (islandEl) {
    islandEl.querySelectorAll('.gni-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.gniIndex, 10);
        if (!isNaN(idx) && idx >= 0) goSlide(idx);
      });
    });
  }

  /* Swipe mobile */
  if (mainEl) {
    let tx = 0;
    mainEl.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    mainEl.addEventListener('touchend', e => {
      const diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      const slides = document.querySelectorAll('.gallery-slide');
      const cur = [...slides].findIndex(s => s.classList.contains('active'));
      if (diff > 0 && cur < slides.length - 1) goSlide(cur + 1);
      if (diff < 0 && cur > 0) goSlide(cur - 1);
    }, { passive: true });
  }

  /* ── Variantes ── */
  const variantInput = document.getElementById('pdp-variant-id');
  const priceEl      = document.getElementById('buy-price');
  const compareEl    = document.getElementById('buy-compare');
  const saveEl       = document.getElementById('buy-save');
  const installEl    = document.getElementById('pdp-installment');
  const stickyPrEl   = document.getElementById('sticky-price');
  const mPrEl        = document.getElementById('m-pdp-price');
  const atcBtn       = document.getElementById('pdp-atc');
  const atcLabel     = document.getElementById('pdp-atc-label');

  function fmt(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €';
  }

  /* ── Klarna OSM — API programmatique du Web SDK ──
     Le SDK ne ré-évalue pas un placement déclaratif modifié ; le cycle
     unmount() / mount() est la voie documentée pour un montant dynamique. */
  const klarnaHost = document.getElementById('pdp-klarna');
  let klarnaSdkPromise = null;
  let klarnaPlacement  = null;

  async function klarnaRender(amount) {
    try {
      if (!klarnaSdkPromise) {
        klarnaSdkPromise = import('https://js.klarna.com/web-sdk/v1/klarna.mjs')
          .then(m => m.KlarnaSDK({ clientId: klarnaHost.dataset.clientId }));
      }
      const klarna = await klarnaSdkPromise;
      if (klarnaPlacement) klarnaPlacement.unmount();
      klarnaPlacement = klarna.Messaging.placement({
        key: 'credit-promotion-badge',
        locale: 'fr-FR',
        purchaseAmount: amount,
        theme: klarnaHost.dataset.theme || 'default'
      });
      klarnaPlacement.mount('#pdp-klarna');
    } catch (e) {
      console.warn('Klarna OSM :', e);
    }
  }

  if (klarnaHost?.dataset.clientId) klarnaRender(parseInt(klarnaHost.dataset.amount, 10));

  function updateVariant(v) {
    if (!v) return;
    const p = fmt(v.price);
    if (priceEl)    priceEl.textContent = p;
    if (stickyPrEl) stickyPrEl.textContent = p;
    if (mPrEl)      mPrEl.textContent = p;

    if (compareEl) {
      if (v.compare_at_price > v.price) {
        compareEl.textContent = fmt(v.compare_at_price);
        compareEl.style.display = '';
        if (saveEl) {
          const pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
          saveEl.textContent = '−' + pct + '%';
          saveEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    if (installEl) {
      if (klarnaHost?.dataset.clientId) {
        klarnaRender(v.price);
      } else if (P.show_installment && v.price >= P.installment_threshold) {
        const amountEl = document.getElementById('pdp-installment-amount');
        if (amountEl) amountEl.textContent = fmt(Math.round(v.price / 3)) + ' × 3';
      } else {
        installEl.style.display = 'none';
      }
    }

    if (variantInput) variantInput.value = v.id;
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? ((window.RemoodStrings || {}).addToCart || 'Ajouter au panier') : ((window.RemoodStrings || {}).unavailable || 'Temporairement indisponible');
    }
  }

  /* Track selected options */
  const selOpts = {};
  document.querySelectorAll('.seg-btn, .swatch-btn, .size-tile').forEach(btn => {
    const pos = parseInt(btn.dataset.optPos, 10);
    if (btn.classList.contains('active')) selOpts[pos] = btn.dataset.optVal;

    btn.addEventListener('click', () => {
      const p = parseInt(btn.dataset.optPos, 10);
      selOpts[p] = btn.dataset.optVal;

      /* Update buttons */
      document.querySelectorAll(`[data-opt-pos="${p}"]`).forEach(b => {
        b.classList.toggle('active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      /* Update label */
      const valEl = document.getElementById(`config-val-${p}`);
      if (valEl) valEl.textContent = btn.dataset.optVal;

      /* Find variant */
      const match = variants.find(v =>
        Object.entries(selOpts).every(([k, val]) => v['option' + k] === val)
      );
      updateVariant(match);
    });
  });

  /* ── Qty stepper ── */
  const qtyInput = document.getElementById('pdp-qty');
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.qty === 'inc' && v < 10) qtyInput.value = v + 1;
      if (btn.dataset.qty === 'dec' && v > 1)  qtyInput.value = v - 1;
    });
  });

  /* ── ATC via fetch ── */
  const form = document.getElementById('pdp-form');
  if (form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (atcBtn?.disabled) return;
      atcBtn?.classList.add('loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantInput?.value, 10),
            quantity: parseInt(qtyInput?.value || 1, 10)
          })
        });
        if (res.ok) {
          atcBtn?.classList.add('success');
          if (atcLabel) atcLabel.textContent = ((window.RemoodStrings || {}).added || 'Ajouté') + ' ✓';

          const cart = await (await fetch('/cart.js')).json();
          document.querySelectorAll('.nav-cart-count, .m-cart-count').forEach(el => {
            el.textContent = cart.item_count > 0 ? cart.item_count : '';
            el.hidden = cart.item_count === 0;
          });
          document.dispatchEvent(new CustomEvent('remood:cart:added', { detail: { cart } }));

          setTimeout(() => {
            atcBtn?.classList.remove('success', 'loading');
            if (atcLabel) atcLabel.textContent = (window.RemoodStrings || {}).addToCart || 'Ajouter au panier';
          }, 2200);
        } else {
          atcBtn?.classList.remove('loading');
        }
      } catch {
        atcBtn?.classList.remove('loading');
        form.submit();
      }
    });
  }

  /* Click sur le bouton sticky ATC */
  document.getElementById('sticky-atc-btn')?.addEventListener('click', () => {
    atcBtn?.click();
  });
  document.getElementById('m-pdp-cta-btn')?.addEventListener('click', () => {
    atcBtn?.click();
  });

  /* ── Barre sticky (desktop) ── */
  const stickyBar = document.getElementById('pdp-sticky-bar');
  if (stickyBar && atcBtn) {
    const obs = new IntersectionObserver(([e]) => {
      stickyBar.classList.toggle('visible', !e.isIntersecting);
      stickyBar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
    }, { rootMargin: '-68px 0px 0px 0px' });
    obs.observe(atcBtn);
  }

  /* ── CTA mobile (bas) ── */
  const mCTA = document.getElementById('m-pdp-cta');
  if (mCTA && atcBtn) {
    const mObs = new IntersectionObserver(([e]) => {
      mCTA.classList.toggle('visible', !e.isIntersecting);
      mCTA.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
    });
    mObs.observe(atcBtn);
  }

  /* ═══════════════════════════════════════════════
     PDP V2 — Galerie hero2
     ═══════════════════════════════════════════════ */
  const hero2Main   = document.getElementById('hero2-main');
  const hero2Thumbs = document.getElementById('hero2-thumbs');

  if (hero2Main && hero2Thumbs) {
    const slides = hero2Main.querySelectorAll('.hero2-slide');
    const thumbs = hero2Thumbs.querySelectorAll('.hero2-thumb');

    function activateHero2(idx) {
      slides.forEach((s, i) => {
        s.classList.toggle('active', i === idx);
        s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
      });
      thumbs.forEach((t, i) => {
        t.classList.toggle('active', i === idx);
        t.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
      });
    }

    thumbs.forEach(btn => {
      btn.addEventListener('click', () => {
        activateHero2(parseInt(btn.dataset.thumb, 10));
      });
    });
  }

  /* ═══════════════════════════════════════════════
     PDP V2 — Configurateur (variantes + options)
     ═══════════════════════════════════════════════ */
  const cfgForm = document.getElementById('pdp-form-v2');

  if (cfgForm && window.RemoodProduct) {
    const variantInput = document.getElementById('pdp-variant-id-v2');
    const totalEl      = document.getElementById('cfg-total');
    const hero2Price   = document.getElementById('hero2-price');
    const configStr    = document.getElementById('cfg-config-str');

    /* État en cours */
    let selectedOptions = {};
    let extraPrice = 0;

    /* Initialiser les options depuis la variante sélectionnée */
    const initVariant = window.RemoodProduct.variants
      ? window.RemoodProduct.variants.find(v => v.id === parseInt(variantInput?.value, 10))
      : null;
    if (initVariant) {
      initVariant.options.forEach((val, i) => { selectedOptions[i + 1] = val; });
    }

    function formatMoney(cents) {
      const fmt = window.RemoodProduct.money_format || '{{amount}} €';
      return fmt.replace('{{amount}}', (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }));
    }

    function findVariant() {
      return (window.RemoodProduct.variants || []).find(v => {
        return v.options.every((opt, i) => selectedOptions[i + 1] === opt);
      });
    }

    function updatePrice() {
      const v = findVariant();
      if (!v) return;
      const total = v.price + extraPrice;
      if (variantInput) variantInput.value = v.id;
      if (totalEl)    totalEl.textContent  = formatMoney(total);
      if (hero2Price) hero2Price.textContent = formatMoney(v.price);
      /* Disable ATC if unavailable */
      const atcBtn = document.getElementById('pdp-atc-v2');
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.querySelector('span') && (atcBtn.querySelector('span').textContent = v.available ? ((window.RemoodStrings || {}).addToCart || 'Ajouter au panier') : ((window.RemoodStrings || {}).unavailable || 'Temporairement indisponible'));
      }
    }

    function updateConfigStr() {
      const parts = Object.values(selectedOptions);
      if (configStr) configStr.textContent = parts.join(' · ');
    }

    /* ── Boutons variantes Shopify ── */
    document.querySelectorAll('[data-opt-pos]').forEach(btn => {
      if (!btn.closest('#configurateur')) return;
      btn.addEventListener('click', () => {
        const pos = parseInt(btn.dataset.optPos, 10);
        const val = btn.dataset.optVal;
        selectedOptions[pos] = val;

        /* Mettre à jour l'affichage du groupe */
        const group = btn.closest('[role="group"]');
        if (group) {
          group.querySelectorAll('[data-opt-pos]').forEach(b => {
            b.classList.toggle('active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
        }
        /* Mettre à jour le label sélectionné */
        const valEl = document.getElementById(`cfg-val-${pos}`);
        if (valEl) valEl.textContent = val;

        updatePrice();
        updateConfigStr();
      });
    });

    /* ── Boutons accessoires + livraison ── */
    document.querySelectorAll('[data-cfg-group]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.dataset.cfgGroup;
        /* Désactiver les autres du même groupe */
        document.querySelectorAll(`[data-cfg-group="${group}"]`).forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        /* Recalculer le supplément total */
        extraPrice = 0;
        document.querySelectorAll('[data-cfg-group].active').forEach(b => {
          extraPrice += parseInt(b.dataset.cfgPrice || 0, 10);
        });

        /* Mettre à jour le label sélectionné du step */
        const step = btn.closest('.cfg-step');
        const selEl = step && step.querySelector('.cfg-selected');
        if (selEl) selEl.textContent = btn.querySelector('.opt-name')?.textContent || '';

        updatePrice();
        updateConfigStr();
      });
    });

    /* Init */
    updatePrice();
    updateConfigStr();

    /* ── Sticky bar V2 déclenche le form v2 ── */
    const stickyAtcV2 = document.getElementById('sticky-atc-btn');
    if (stickyAtcV2) {
      stickyAtcV2.addEventListener('click', () => {
        const atcBtn = document.getElementById('pdp-atc-v2');
        if (atcBtn) { atcBtn.click(); }
        else { document.getElementById('configurateur')?.scrollIntoView({ behavior: 'smooth' }); }
      });
    }
  }

})();
